import Pagination from '@/model/Pagination';
import Sort from '@/model/SortReq';

export default function (other) {
  other = other || {};
  return {
    // Filter fields
    campaign: other.campaign || '',
    facebookAccountNumber: other.facebookAccountNumber || '',
    agencyName: other.agencyName || '',
    keitaroCampaignName: other.keitaroCampaignName || '',
    setNumber: other.setNumber || '',
    status: other.status || '',
    importance: other.importance || '',
    pixel: other.pixel || '',
    dailySpend: other.dailySpend ?? null,
    creationTime: other.creationTime || null,
    toDo: other.toDo || '',
    note: other.note || '',
    trackingLink: other.trackingLink || '',
    alias: other.alias || '',
    catalog: other.catalog || '',
    catalogLink: other.catalogLink || '',
    facebookOrDrive: other.facebookOrDrive || '',
    filesAndMedia: other.filesAndMedia || '',
    assignedTo: other.assignedTo || '',
    priority: other.priority || '',
    formula: other.formula || '',
    orgIds: other.orgIds || [],
    buIds: other.buIds || [],
    userId: other.userId || '',

    // Search
    search: other.search || '',

    // Pagination & Sorting
    pagination: other.pagination || Pagination(),
    sort: other.sort || Sort()
  };
}
